import { InfoCardProps } from "@omni/types/components/props/infoCard.props";

import { InfoCard } from "./infoCard";

const InfoCardDefault = ({
    description,
    icon,
    iconAltText,
    link,
    linkLabel,
    title
}: InfoCardProps) => {
    return (
        <InfoCard>
            <InfoCard.Header>
                <InfoCard.Header.Title>{title}</InfoCard.Header.Title>
                {icon && (
                    <InfoCard.Header.Icon
                        src={icon}
                        alt={iconAltText || title}
                    />
                )}
            </InfoCard.Header>
            <InfoCard.Body>
                <InfoCard.Body.Content>{description}</InfoCard.Body.Content>
                {link && linkLabel && (
                    <InfoCard.Body.Link href={link}>
                        {linkLabel}
                    </InfoCard.Body.Link>
                )}
            </InfoCard.Body>
        </InfoCard>
    );
};

export { InfoCardDefault };
